import { Box, Checkbox, IconButton, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { motion } from "framer-motion";
import React, { useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';


function WordBox({checked,index, word, handleRemoveWord, handleToggleCheck}) {

    let theWord = ''
    let first_definition = ''
    
    console.log(typeof word) 
    if(typeof word === 'string'){
      theWord = word;
      first_definition = 'Please add this word again to get its definition';
    } else {
      theWord = word.word;
      first_definition = word.meanings[0].definitions[0].definition;
    }
  
  
    const [isOpen,setIsOpen] = useState(false);

    const deleteWord = () => {
      handleRemoveWord(index);
      setIsOpen(false);
    }
  
    return (
    <motion.div transition={{layout:{duration : 0.5, type:'spring'}}} layout="position"  className='card'>
      
      <Paper item key={index} className="word-box"  
      sx={{
        flexDirection:'column',
        alignItems:'flex-start',
        display: 'inline-flex',
      }}>
        <motion.div layout="position">
        <Box  sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: 0,
        paddingX: 0,
        margin: 0, // Adjust the margin as needed
        marginBottom: 0, // Adjust the spacing between the boxes
      }}>
          {!isOpen ?
          <IconButton aria-label="expand" onClick={() => {
            setIsOpen(!isOpen)
            console.log(word.meanings)
            }}>
            <ExpandMoreIcon/>
          </IconButton>
          :
          <IconButton aria-label="expandLess" onClick={() => setIsOpen(!isOpen)}>
            <ExpandLessIcon/>
          </IconButton>
          }
          <Typography style={{fontFamily:'Raleway', fontWeight:'600'}}>
            {/* {word.data[0].word} */}
            {theWord}
          </Typography>
          {isOpen && <IconButton aria-label="delete" onClick={() => deleteWord()}>
            <DeleteIcon style={{ fontSize: '22px' }}/>
          </IconButton>}
          {/* <Button onClick={() => getMerriamDef(word)}>
            get
          </Button> */}
          <Checkbox checked={checked} onChange={() => handleToggleCheck(index)} />
        </Box>
        </motion.div>
      {isOpen &&
        <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.7}} layout="position">
  
          <Box sx ={{m:1,maxWidth:250}}>
            {/* <Typography sx={{fontSize:14,marginTop:-2}}>
              A lot of text to check it out, you know. wefwiej ifjwef
              w ef wiefj iwejf jwief jiwej foweif joewif jwoei joewi jowei jfoewi
              wef we
              {first_definition}
            </Typography> */}
            <Typography sx={{fontSize:14,marginTop:-2}}>
              {first_definition}
            </Typography>
  
          </Box>
        </motion.div>
  
      }
      </Paper>
  
    </motion.div>
  
    );
  }

  export default WordBox